import type IHttpEventHandler from "@/domain/ports/IHttpEventHandler";
import paths from "@/router/paths";
import VueRouter from "vue-router";


export default class HttpEventHandler implements IHttpEventHandler {
  constructor(private router: VueRouter) { }

  onUnAuthenticated() {
    this.router.push(`${paths.login}`);
  }

}
